'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { TableHeaderCellContext } from './context/table-header-cell.context';
import type { TableHeaderPropsInterface } from './types/table-header.types';

/**
 * A native [`<thead>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/thead) element.
 *
 * @since 8.0.0
 */
export const TableHeader = forwardRef<HTMLTableSectionElement, TableHeaderPropsInterface>(
  (props: TableHeaderPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, sticky = false, ...rest } = props;

    return (
      <TableHeaderCellContext.Provider value={{ parent: 'header', sticky }}>
        <thead
          ref={forwardedRef}
          data-c11n-version={__C11N_VERSION__}
          data-c11n-component="Table.Header"
          className={cx('c11n', css(cssProp), className)}
          {...rest}
        >
          {children}
        </thead>
      </TableHeaderCellContext.Provider>
    );
  },
);

TableHeader.displayName = 'Table.Header';
